"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Rating = void 0;
const lib_palette_1 = __importDefault(require("@opsbase/lib-palette"));
const StarIcon_1 = __importDefault(require("@opsbase/web-icons/icons/StarIcon"));
const Horizontal_1 = __importDefault(require("@opsbase/web-layout/Horizontal"));
const range_1 = __importDefault(require("lodash/range"));
const react_1 = __importDefault(require("react"));
function Rating(props) {
    const { value, color = lib_palette_1.default.secondary } = props;
    return (react_1.default.createElement(Horizontal_1.default, { justify: "flex-start" }, (0, range_1.default)(5).map(i => (react_1.default.createElement(StarIcon_1.default, { key: i, htmlColor: i <= value ? color.main : lib_palette_1.default.BackgroundGrey.main })))));
}
exports.Rating = Rating;
exports.default = Rating;
